/** @jsxImportSource @emotion/react */
"use client";
import type { Interpolation } from "@emotion/react";

import { spacing } from "../../../../../global/emotion";
import { cssMediaQueryMinWidthTablet } from "../../../../lib/constants/emotionMediaQueries.constants";
import type { HallowElementProps } from "../../../../types/hallowElementProps.types";

const headerContainerStyle: Interpolation = {
  alignItems: "center",
  display: "flex",
  gap: spacing.xxs,
  justifyContent: "space-between",
  paddingBottom: spacing.xxs,
  paddingLeft: spacing.m,
  paddingRight: spacing.m,
  paddingTop: spacing.none,
  [cssMediaQueryMinWidthTablet]: {
    paddingTop: spacing.m,
    paddingBottom: spacing.m,
  },
  width: spacing.full,
};

type PanelHeaderProps = HallowElementProps<"div">;

export const PanelHeader = ({ children, ...props }: PanelHeaderProps) => {
  return (
    <div css={headerContainerStyle} {...props}>
      {children}
    </div>
  );
};
